import React from "react";

const NavigationButton = ({
  icon: Icon,
  label,
  path,
  textColor = "",
  className = "",
  style,
  newTab = false, // default: same tab
}) => (
  <a
    href={path}
    target={newTab ? "_blank" : "_self"}
    rel={newTab ? "noopener noreferrer" : undefined}
    style={style}
    className={`${className} text-decoration-none ${textColor}`}
  >
    {Icon && <Icon className="ms-1 me-2" />}
    <span>{label}</span>
  </a>
);

export default NavigationButton;
